// extracted by mini-css-extract-plugin
export default {"PhoneIconRow":"Izyi9zbNdKA--ZO1fno4nw=="};